<script setup>
import { twMerge } from "tailwind-merge";

const props = defineProps({
    class: String,
});
</script>

<template>
    <div></div>
    <div :class="[twMerge('p-4 bg-white rounded-lg border group relative border-gray-300 dark:bg-gray-900 dark:border-gray-800', props.class)]">
        <slot></slot>
    </div>
</template>
